import styled from 'styled-components';

const PaginationStyle = styled.div`
	--paginationItemSizes: var(--sp4x);
	--paginationItemMargin: var(--sp0-5x);

	.pagination__list {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.disable {
		pointer-events: none;
		opacity: 60%;
	}

	.dots {
		margin: 0 var(--paginationItemMargin);
	}

	.pagination-item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: var(--paginationItemSizes);
		height: var(--paginationItemSizes);
		margin: 0 var(--paginationItemMargin);
		cursor: pointer;

		&.active {
			pointer-events: none;
			background-color: var(--birodoGreen);
			color: var(--red100);
			text-decoration: underline;
			text-underline-offset: var(--sp0-5x);
		}
	}

	.next-btn,
	.prev-btn {
		display: flex;
		align-items: center;
		margin: 0 var(--paginationItemMargin);
		cursor: pointer;

		&.disable {
			display: none;
		}
	}

	.next-btn {
		margin-right: unset;
	}

	.prev-btn {
		transform: rotate(180deg);
		margin-left: unset;
	}
`;

export default PaginationStyle;
